export default __webpack_public_path__ + "static/media/Ghana.94b0619c.svg";